import { useQuery } from '@tanstack/react-query';
import { 
  fetchNetworkProfessionals, 
  type NetworkProfessionalsResponse 
} from '../api/networkApi';

/**
 * React Query hook to fetch and manage network professionals data for dashboard
 * Returns up to 10 most recently added professionals (both SP and FA) with pagination metadata
 *
 * @returns Query result with network professionals response (data, total, hasMore), loading state, and error state
 */
export function useNetworkProfessionals() {
  return useQuery<NetworkProfessionalsResponse, Error>({
    queryKey: ['advisor', 'network', 'professionals'],
    queryFn: fetchNetworkProfessionals,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true,
  });
}

/**
 * Legacy hook alias for backward compatibility
 * @deprecated Use useNetworkProfessionals instead
 */
export const useNetworkProviders = useNetworkProfessionals;
